import { useCallback } from 'react';

import { useChangePlanDetails } from '../../providers';
import { ChangePlanActionTypes } from '../../reducer/changePlan.reducer';

export const useChangePlanActionLayer = () => {
  const { dispatch, userInfoUpdate, showActionLayer, viewState } =
    useChangePlanDetails();

  const closeActionLayer = useCallback(
    () =>
      dispatch({
        type: ChangePlanActionTypes.CloseActionLayer,
      }),
    [dispatch],
  );

  const navigateToAccountSelect = useCallback(
    () =>
      dispatch({
        type: ChangePlanActionTypes.SetChangeAccount,
      }),
    [dispatch],
  );

  const navigateToLineSelect = useCallback(
    () =>
      dispatch({
        type: ChangePlanActionTypes.SetChangeLine,
      }),
    [dispatch],
  );

  return {
    ...userInfoUpdate,
    showActionLayer,
    viewState,
    closeActionLayer,
    navigateToAccountSelect,
    navigateToLineSelect,
  };
};
